import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CustomerGuard } from '../shop/guards/customer.guard';
import { IsSignedInGuard } from '../shop/guards/is-signed-in.guard';
import { AccountLayoutComponent } from './containers/account-layout/account-layout.component';
import { AccountProfileEditComponent } from './containers/account-profile-edit/account-profile-edit.component';
import { AccountProfileComponent } from './containers/account-profile/account-profile.component';
import { AccountOrderOverviewComponent } from './containers/account-order-overview/account-order-overview.component';
import { OrdersGuard } from '../shop/guards/orders.guard';
import { AccountOrderDetailComponent } from './containers/account-order-detail/account-order-detail.component';
import { AccountEditAddressesComponent } from './containers/account-edit-addresses/account-edit-addresses.component';
import { AddressesGuard } from '../shop/guards/addresses.guard';
import { ShopDataGuard } from '../shop/guards/shop-data.guard';

const routes: Routes = [
  {
    path: '',
    component: AccountLayoutComponent,
    canActivate: [IsSignedInGuard, CustomerGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: AccountProfileComponent,
        canActivate: [IsSignedInGuard, CustomerGuard, AddressesGuard],
      },
      {
        path: 'bewerken',
        component: AccountProfileEditComponent,
        canActivate: [IsSignedInGuard, CustomerGuard, AddressesGuard],
      },
      {
        path: 'orders',
        component: AccountOrderOverviewComponent,
        canActivate: [IsSignedInGuard, CustomerGuard, OrdersGuard],
      },
      {
        path: 'orders/:id',
        component: AccountOrderDetailComponent,
        pathMatch: 'full',
        canActivate: [IsSignedInGuard, CustomerGuard, OrdersGuard],
      },
      {
        path: 'add-address',
        component: AccountEditAddressesComponent,
        canActivate: [IsSignedInGuard, CustomerGuard, AddressesGuard, ShopDataGuard],
        data: {
          type: 'toevoegen',
        },
      },
      {
        path: 'edit-address/:id',
        component: AccountEditAddressesComponent,
        canActivate: [IsSignedInGuard, CustomerGuard, AddressesGuard, ShopDataGuard],
        data: {
          type: 'bewerken',
        },
      },
      {
        path: ':id',
        pathMatch: 'full',
        component: AccountOrderDetailComponent,
        canActivate: [IsSignedInGuard, CustomerGuard, OrdersGuard],
      },
    ],
  },
  //{
  //  path: 'login',
  //  redirectTo: '/auth/inloggen',
  //},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AccountRoutingModule {}
